import React, {createContext, useState, useEffect} from "react";

const ThemeContext = createContext();

export default ThemeContext;

export const ThemeProvider = ({children}) => {
    const currentDomain = window.location.hostname;
    const isOrionaiot = currentDomain.toLowerCase().includes("orionaiot");
    const cssTheme = isOrionaiot ? "purple" : "blue";

    const [theme, setTheme] = useState({
        logoTopbar: "/static/images/quamtra_manager.svg",
        logoLogin: "/static/images/quamtra_manager-black.svg",
        primaryColor: "#0066cc",
        title: "Welcome to Quamtra APP",
        cssTheme: cssTheme,
        loading: true,
    });

    useEffect(() => {
        const loadTheme = async () => {
            try {
                const currentDomain = window.location.hostname;

                const response = await fetch(`/api/theme/config/?domain=${currentDomain}`);
                if (response.ok) {
                    const data = await response.json();
                    const faviconEl = document.querySelector("link[rel='icon']");
                    if (faviconEl) faviconEl.href = data.favicon;
                    setTheme({...data, cssTheme: cssTheme, loading: false});
                    document.title = data.title;
                } else {
                    setTheme((prev) => ({...prev, loading: false}));
                }
            } catch (error) {
                console.error("Error fetching theme:", error);
                setTheme((prev) => ({...prev, loading: false}));
            }
        };
        loadTheme();
    }, [cssTheme]);

    const contextData = {
        theme,
        setTheme,
    };

    return <ThemeContext.Provider value={contextData}>{children}</ThemeContext.Provider>;
};
